import { useMemo } from 'react';
import { useClusterKeysQuery } from '../../../../hooks/api';

export const useClusterData = (accountID: number, advertiserID: number, suppressedIncluded: boolean = false) => {
  const { data, isLoading, isSuccess, isError, error } = useClusterKeysQuery(
    {
      accountID: accountID,
      advertiserID: [advertiserID],
      suppressedIncluded,
    },
    {
      enabled: !!accountID && !!advertiserID,
      staleTime: Infinity,
    },
  );

  const hasClusterError = useMemo(() => isError || (!!data && !data.data.length), [data, isError]);

  return {
    hasClusterError,
    clusterKeys: data,
    // @ts-expect-error ts(2339)
    errorMessage: error?.error_desc,
    isError,
    isSuccess,
    isLoading,
  };
};
